<template>
    <div class="row">
        <div class="col-12">
            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-6 card-header-search-box">
                    <div class="input-group">
                        <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search"
                               @keypress.enter="initList">
                        <div class="input-group-append">
                            <button class="all-btn search-btn" @click="initList">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 card-header-select-box mt-2 mt-sm-0">
                    <div class="form-group">
                      <label style="color: grey">{{$t("common.status")}}</label>
                      <div class="position-relative">
                        <select class="form-control"
                                v-model="filter.status"
                                @change="onChangeVisibleState">
                          <option value=""></option>
                          <option value="ACTIVE">ACTIVE</option>
                          <option value="DEACTIVATED">DEACTIVATED</option>
                          <option value="DELETED">DELETED</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" @click="showPurposesRentingAreasItemAddEditModal(null)">
                  {{$t("action.add")}}
                </button>
              </div>

            </div>
        </div>
        <div class="col-12 mt-3">
<!--            <div class="container-fluid" style="padding-top: 10px;">
                <template v-if="!loading && results && results.data" style="min-width: max-content;">
                    <div class="row" style="background-color: #48D1CC;">
                        <div class="col-sm-1">№</div>
                        <div class="col-sm-8">Номи</div>
                        <div class="col-sm-2">Актив</div>
                        <div class="col-sm-1">{{$t("realEstate.field.action")}}</div>

                    </div>
                    <div class="row-fluid" v-for="result in results.data" :key="result.id">
                        <div>
                            <div class="row" style="background-color: #ADD8E6;">
                                <div class="col-sm-11 text-center"><h3 class="font-weight-normal">{{result.name}}</h3>
                                </div>
                                <div class="col-sm-1 d-flex align-items-center">
                                    <button
                                            class="all-btn add-btn"
                                            data-original-title="Close"
                                            @click="purposeRentingAreasDeactivated(result.id)">
                                        <i class="fa fa-close"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="row" v-for="child in result.childFields" :key="child.id"
                                 style=" border-bottom: 1px solid black;">
                                <div class="col-sm-1">{{child.id}}</div>
                                <div class="col-sm-8">{{child.name}}</div>
                                <div class="col-sm-2">{{child.visibleState}}</div>
                                <div class="col-sm-1">
                                    <button class="all-btn edit-btn"
                                            data-original-title="Close"
                                            @click="purposeRentingAreasItemDeactivated(child.id)">
                                        <i class="fa fa-close"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                </template>
            </div>-->

            <div class="table-wrapper" v-if="!loading && results && results.data">
              <table class="table" style="min-width: 900px;">
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Номи</th>
                    <th>Актив</th>
                    <th>{{$t("realEstate.field.action")}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(result, index) in results.data">
                    <tr style="background-color: #ADD8E6;" :key="index + 1000">
                      <td colspan="3" class="text-center">
                        <h3 class="font-weight-normal">{{result.name}}</h3>
                      </td>
                      <td>
                        <button class="all-btn add-btn" data-original-title="Close"
                                @click="purposeRentingAreasDeactivated(result.id)">
                          <i class="fa fa-close"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-for="child in result.childFields" :key="child.id">
                      <td>{{child.id}}</td>
                      <td>{{child.name}}</td>
                      <td>{{child.visibleState}}</td>
                      <td>
                        <button class="all-btn edit-btn"
                                data-original-title="Close"
                                @click="purposeRentingAreasItemDeactivated(child.id)">
                          <i class="fa fa-close"></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>


            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size"
                                  @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <PurposesRentingAreasItemAddEditModal/>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import PurposesRentingAreasItemAddEditModal from '@/views/config/rental_rates/PurposesRentingAreasItemAddEditModal';

    export default {
        name: "PurposesRentingAreasItemList",
        components: {
            'b-pagination': bPagination,
            PurposesRentingAreasItemAddEditModal: PurposesRentingAreasItemAddEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                lastId: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('rental-rates/purposes-renting-areas/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },

            purposeRentingAreasItemDeactivated(id) {
                const vm = this;
                if (id) {
                    this.loading = true;
                    this.$http.get('rental-rates/purposes-renting-areas-item/deactivated/' + id)
                        .then(res => {
                            const response = res.data;
                            if (response.status === 'SUCCESS') {
                                vm.show = false;
                                this.$eventBus.$emit('purposesRentingAreasItemChanged', response);
                            }
                        }, (err) => {
                            console.log(err);
                            vm.loading = false;
                        });
                }

            },
            purposeRentingAreasDeactivated(id) {
                const vm = this;
                if (id) {
                    this.loading = true;
                    this.$http.get('rental-rates/purposes-renting-areas/deactivated/' + id)
                        .then(res => {
                            vm.loading = false;
                            const response = res.data;
                            if (response.status === 'SUCCESS') {
                                vm.show = false;
                                this.$eventBus.$emit('purposesRentingAreasItemChanged', response);
                            }

                        }, (err) => {
                            console.log(err);
                            vm.loading = false;
                        });
                }

            },

            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onChangeVisibleState() {
                this.filter.page.page = 1;
                this.initList()
            },
            showPurposesRentingAreasItemAddEditModal(data) {
                this.$eventBus.$emit('showPurposesRentingAreasItemAddEditModal', data);
            },
            showTr(id) {
                console.log("lastId", this.lastId);
                if (this.lastId == null && id != null) {
                    this.lastId = id;
                    console.log("true");
                    return true;
                } else if (this.lastId != null && this.lastId != id) {
                    this.lastId = id;
                    console.log("true");
                    return true;
                }
                console.log("false");
                return false;
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('purposesRentingAreasItemChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>
    h3 {
        display: block;
        font-size: 1.17em;
        margin-top: 1em;
        margin-bottom: 1em;
        margin-left: 0;
        margin-right: 0;
        font-weight: bold;
    }

</style>